export const ISSUER_URL = process.env.REACT_APP_ISSUER_URL || 'https://auth.nimey-local.de/realms/nimey/.well-known/openid-configuration';
export const CLIENT_ID = process.env.REACT_APP_CLIENT_ID || 'local-dev-frontend';